import { render, staticRenderFns } from "./NewDispatch.vue?vue&type=template&id=750abb26&scoped=true"
import script from "./NewDispatch.vue?vue&type=script&lang=js"
export * from "./NewDispatch.vue?vue&type=script&lang=js"
import style0 from "./NewDispatch.vue?vue&type=style&index=0&id=750abb26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750abb26",
  null
  
)

export default component.exports